import { Store } from 'store/index';
import getIsInitialProduct from './getIsInitialProduct';
import getProductId from './getProductId';

const getPersonalisedProductPreviews = (store: Store) => {
  const productId = getProductId(store);
  const isInitialProduct = getIsInitialProduct(store);
  if (isInitialProduct) {
    if (!store.product.personalisedProduct || !store.product.personalisedProduct.abstractProduct) {
      return [];
    }
    return store.product.personalisedProduct.images as string[];
  }

  const targetProduct = store.product.personalisedProduct?.abstractProduct?.products?.find(
    (productItem) => productItem.productId === productId,
  );
  return (
    targetProduct && targetProduct.previews?.length
      ? targetProduct.previews
      : store.product.personalisedProduct?.images || []
  ) as string[];
};

export default getPersonalisedProductPreviews;
